import styled from '@emotion/styled';
import { Select as BaseSelect } from 'antd';

import colors from 'config/theme/colors';

const Select = styled(BaseSelect)`
  &.block {
    width: 100%;
  }

  &.highlight {
    background-color: #f5f8ff;
    border: 1px solid ${colors['@primary-color-dark']};
  }

  &.blue {
    width: 100%;

    position: relative;

    > .ant-select-suffix {
      position: absolute;
      top: 12px;
      inset-inline-end: 13px;
    }

    /* rc renders the prefix slot as a sibling of the content, so the search label is laid over the
       search row, which is sticky with an opaque background at z-index 1. */
    > .ant-select-prefix {
      position: absolute;
      top: 0;
      inset-inline-start: 13px;
      z-index: 2;
      height: 40px;
      display: flex;
      align-items: center;
      color: #bfbfbf;
      pointer-events: none;
    }

    &.ant-select-open > .ant-select-prefix {
      display: none;
    }

    > .ant-select-content {
      max-height: 250px;
      overflow-x: hidden;
      overflow-y: auto;
      gap: 12px;
      padding: 0 13px 12px;

      /* antd keeps a zero-width pseudo in the content as a line-height stabilizer; as a flex item
         it collects one gap and pushes the first pill 12px right. */
      &::before {
        display: none;
      }

      > .ant-select-content-item-suffix {
        order: -1;
        flex: 0 0 100%;
        position: sticky;
        top: 0;
        z-index: 1;
        background: #fff;
        border-bottom: 1px solid #dbdddf;

        input.ant-select-input {
          width: 100%;
          height: 40px;
        }
      }

      > div {
        .ant-select-selection-item {
          /* antd gives every selection item its own 2px 4px margin; spacing comes from the gap. */
          margin: 0;
          color: ${colors['@primary-color-darker']};
          background-color: ${colors['@item-hover-bg']};
          border: solid 1px #8bb8e8;
          padding: 3px 8px;
          height: 30px;
          line-height: 24px;

          &:hover {
            background-color: #c3d7ee;
          }

          > .ant-select-selection-item-content {
            margin-right: 8px;
          }

          > .ant-select-selection-item-remove {
            color: ${colors['@primary-color-darker']};
          }

          &.inactive {
            color: ${colors['@font-grey-light']};
            border-color: ${colors['@border-color-base']};
            background-color: ${colors['@body-bg']};

            &:hover {
              background-color: rgb(247 248 250 / 50%);
            }

            .disabled-flag {
              font-weight: bold;
              text-transform: uppercase;
              color: ${colors['@font-grey-light']};

              &::after {
                content: '-';
                margin: 0 4px;
              }
            }

            > .ant-select-selection-item-remove {
              color: ${colors['@font-grey-light']};
            }
          }
        }
      }
    }
  }
`;

export default Select;
